// export const baseUrl = "http://localhost:8081/api";
// export const frontBaseUrl = "http://localhost:3000";
export const baseUrl = "https://building-fmis.onrender.com/api";
export const frontBaseUrl = "https://sunsky.netlify.app";

export const userRoles = {
  admin: "admin",
  superadmin: "superadmin",
  finance: "finance",
  system_user: "system_user",
};
export const userPermissions = {
  create: "CREATE",
  read: "READ",
  update: "UPDATE",
  delete: "DELETE",
};
